import { AfterViewInit, Component, inject, input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { StepperNavigationService } from "../../../services/stepper-navigation.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute,Data, Router  } from "@angular/router";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
} from "@cvx/nextpage";
import { CalcTemplate } from "../../../services/calctemplate";
import { MAWPComponent } from '../../mawp/mawp.component';
import { MAEPComponent } from '../../maep/maep.component';
import { MFHComponent } from '../../mfh/mfh.component';
import { Subject, Subscription } from "rxjs";
import { Component_MAWP } from "../../../services/component_mawp";
import { Component_MAEP } from "../../../services/component_maep";
import { GML_module } from "../../../services/gml_module";
import { Form1 } from "../../../services/form1";
import { MatStepper } from "@angular/material/stepper";
import { FormControlsEventProxyService } from "../../../services/formcontrols_eventproxy_service";
import { MatRadioChange } from "@angular/material/radio";
import { MatDialog,MatDialogConfig } from "@angular/material/dialog";
import { VerticalvesselComponent } from "../../type-a-component/verticalvessel/verticalvessel.component";
import { HorizontalvesselComponent } from "../../type-a-component/horizontalvessel/horizontalvessel.component";
import { CarbonsteelandlowalloysteelComponent } from "../../type-a-component/carbonsteelandlowalloysteel/carbonsteelandlowalloysteel.component";
import { HighalloyandnonferroussteelComponent } from "../../type-a-component/highalloyandnonferroussteel/highalloyandnonferroussteel.component";
import { Overlay } from "@angular/cdk/overlay";
import { WarningModalComponent } from "../../warning-modal/warning-modal.component";
import { ComponentTypeData } from "../../models/component-type";
import { ComponentEventService } from "projects/fitnessforservice/src/services/component_event.service";
import { SupplementalLoadsService, SupplementalLoadsData } from "../../../services/supplemental-loads.service";
import { ModuleConfigService, AssessmentModule } from "../../../services/module-config.service";



@Component({
    selector: "general-metal-loss",
    templateUrl: "general-metal-loss.component.html",
    standalone: false
})
export class GeneralMetalLossComponent implements OnInit {
  supplementalLoadsSelection: string = '';
  generalmetalloss_formGroup: FormGroup;
  @ViewChild("stepper") private myStepper: MatStepper;
  private readonly stepNav = inject(StepperNavigationService);
  private readonly syncLinear = (linear: boolean) => (this.isLinear = linear);
  @ViewChild('mawpComponent') mawpComponent!: MAWPComponent;
  @ViewChild('maepComponent') maepComponent!: MAEPComponent;
  @ViewChild('mfhComponent') mfhComponent!: MFHComponent;

  totalStepsCount: number;
  inspectionDataCalculate: Subject<boolean> = new Subject();
  applicability: string;
  // applicability1: string;
  // applicability2: string;
  // applicability3: string;
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  path: string;
  reevaluSub: any;  
 //Shameer 
 typeA : number;
 isreevalu = true;
// ComponentTypeData : Data[];
  tooltipText1: string = '';
  tooltipText2: string = '';
  tooltipText3: string = '';
  tooltipText4: string = ''; 
  intUnittype:number;

  // Level 2 Assessment properties
  showLevelOfAssessment: boolean = false;  // Show Level of Assessment radio for vertical vessels
  showSupplementalLoads: boolean = false;  // Show supplemental loads section for vertical vessels (screening fail)
  showSupplementalInputs: boolean = false; // Show M, F, alpha inputs when supplemental loads available
  supplementalLoadsAvailable: string = ''; // 'yes' or 'no'
  supplementalMessage: string = '';        // Message when supplemental loads not available
  levelOfAssessment: string = 'level1';    // 'level1' or 'level1and2'
  isVerticalVessel: boolean = false;       // Whether current selection is vertical vessel
  verticalScreeningPassed: boolean = false; // Whether vertical vessel screening passed

  public gml_module = GML_module;
  public component_mawp = Component_MAWP;

   public component_maep = Component_MAEP;
  summary: string;
  inspectionDataResult: string;
  result: string;
  SelectedValue: string;
  isCheckboxDisabled = false;
  isCylAtmradio = false; // always disabled this radio button for the current requirement
  // isfirstnextbut = true;
   validationList = [];
    basicValidationLabel: string =
    "Following inputs have invalid information.";
  showDIRequiredMessage: boolean = false;

  firstFormGroup = this._formBuilder.group({
    applicabilityCheckbox: ["", Validators.requiredTrue],
    typeACheckbox:["",Validators.required],
    radio:["",],
    Applibltynextbutton:["",],
    
  });
  secondFormGroup = this._formBuilder.group({});
  isLinear = true;
  private routePageSubscription: Subscription;

  private readonly gmlSummaryStorageKey = "gml_summary_html";
  private readonly gmlInspectionResultStorageKey = "gml_inspection_result_html";

  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder,
    private formControlsEventProxyService: FormControlsEventProxyService,
    public dialog: MatDialog,
    private componentService: ComponentEventService,
    private supplementalLoadsService: SupplementalLoadsService,
    private moduleConfigService: ModuleConfigService
  ) {
    this.GML_Assesment_Setup();
    this.path = activatedRoute.snapshot["_routerState"].url;
    this.generalmetalloss_formGroup = this._formBuilder.group({
      radioButton_DI: ["", Validators.required]
    });
      //shameer   
      this.firstFormGroup.get('typeACheckbox').disable();
      this.firstFormGroup.get('applicabilityCheckbox').disable();
       
  }

  goToComponent() {

          const isCylindricalAtmosphericSelected = Number(this.firstFormGroup.get('radio')?.value) === 7;
          if (isCylindricalAtmosphericSelected && !this.firstFormGroup.get('applicabilityCheckbox')?.value) {
            this.dialog.open(WarningModalComponent, {
              width: "450px",
              data: {
                warningMessage: [
                  "For Cylindrical atmospheric storage tank shell courses, select 'All the conditions listed above are met.' before proceeding.",
                ],
                caption: "FFS: Applicability and Limitations",
                captionCenter: true,
                cancelButtonShow: false,
              },
            });
            return;
          }


          if(((this.firstFormGroup.get('radio').value) != null) &&
          ((this.firstFormGroup.get('applicabilityCheckbox').enabled == true ) ||
          (this.firstFormGroup.get('typeACheckbox').enabled == true))
        )
      {
          this.firstFormGroup.controls["applicabilityCheckbox"].markAsDirty({
            onlySelf: true,
          });
          this.firstFormGroup.controls["applicabilityCheckbox"].markAsTouched({
            onlySelf: true,
          });
        
            //shameer
            let typAcheckbox1 = this.firstFormGroup.controls["typeACheckbox"];
            typAcheckbox1.markAsDirty({
              onlySelf: true,
            });
            typAcheckbox1.markAsTouched({
              onlySelf: true,
            });

          this.goNextStep();
        }else{
          this.dialog.open(WarningModalComponent, {
            width: "450px",
            data: {
              warningMessage: [
                "Select an Option to Proceed!..Please.",
              ],
              caption: "FFS: Applicability and Limitations",
              captionCenter: true,
              cancelButtonShow: false,
            },
          });
      
      
        }
  }
  //Sooraj Added this Code
  onNextClickcalculateSummary() {
    if (this.isMfhMode) {
      this.mfhComponent?.calculateSummary();
      return;
    }

    const selected = this.generalmetalloss_formGroup.get('radioButton_DI')?.value;
    if (selected.toString().toUpperCase() === 'radioButton1_DI_enabled'.toString().toUpperCase()) {
      this.mawpComponent?.calculateSummary();
    } else if (selected.toString().toUpperCase() === 'radioButton2_DI_enabled'.toString().toUpperCase()) {
      this.maepComponent?.calculateSummary();
    } else {
      // No selection: keep user on Component step; message is already shown in template
      console.warn('Please select a pressure type.');
      return;
    }
  }

  getApplicabilityCheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("applicabilityCheckbox") as FormControl;
  }
  gettypeAcheckbox_formControl():FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }
  getRadioButton_DI_formControl(): FormControl {
    return this.generalmetalloss_formGroup.get("radioButton_DI") as FormControl;
  }

  get isMfhMode(): boolean {
    return Number(this.firstFormGroup.get('radio')?.value) === 7;
  }
  
  goNextStep() {
    const applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    const typeACheckbox = this.gettypeAcheckbox_formControl();
    const diControl = this.getRadioButton_DI_formControl();
    const currentIndex = this.myStepper?.selectedIndex ?? 0;
    const isAtApplicability = currentIndex === 0;
    const typeARadioVal = this.firstFormGroup.get('radio')?.value;
    const isSphericalSelected = isAtApplicability && Number(typeARadioVal) === 5;
    const isCylindricalAtmosphericSelected = isAtApplicability && Number(typeARadioVal) === 7;
    const skipsLoadStep = Number(typeARadioVal) === 5 || Number(typeARadioVal) === 7;

    // Skip Type of Load (Step 2) when Type A radio is '5' or '7' (Spherical or Cylindrical Atmospheric)
    const shouldSkipLoadStep = isSphericalSelected || isCylindricalAtmosphericSelected; // also skip if Cylindrical Atmospheric is selected as per current requirement

    if (shouldSkipLoadStep) {
      if (isCylindricalAtmosphericSelected) {
        const defaultMfhDI = 'radioButton1_DI_enabled';
        diControl.setValue(defaultMfhDI);
        this.onChangeRadioButton1_DI(defaultMfhDI);
      } else {
        // Keep existing behavior for spherical skip flow
        if (!diControl.value) {
          const defaultDI = (this as any).componentService?.radioButtonDI;
          if (defaultDI) {
            diControl.setValue(defaultDI);
            this.onChangeRadioButton1_DI(defaultDI);
          } else {
            diControl.reset('');
          }
        }
      }

      this.stepNav.goToIndex(this.myStepper, currentIndex + 2, this.syncLinear);
      return;
    }

    // Spherical and MFH paths skip the Type of Load step by design. Bypass linear
    // gating when moving from Component (step 3/index 2) to Inspection Data (step 4/index 3).
    if (skipsLoadStep && currentIndex === 2) {
      this.stepNav.goToIndex(this.myStepper, currentIndex + 1, this.syncLinear);
      return;
    }

    // Next from Inspection Data opens the routed Results page state.
    if (currentIndex === 3) {
      this.stepNav.goToIndex(this.myStepper, 4, this.syncLinear);
      this.updateGmlPageQueryParam("results");
      return;
    }

    // Normal advance; respects linear validation
    const accepted =
      applicabilityCheckbox.value === true || typeACheckbox.value === true;
    this.stepNav.next(this.myStepper, accepted);
}

  goPreviousStep() {
    const currentIndex = this.myStepper.selectedIndex;
    const typeARadioVal = this.firstFormGroup.get('radio')?.value;
    const isSphericalSelected = Number(typeARadioVal) === 5;
    const isCylindricalAtmosphericSelected = Number(typeARadioVal) === 7;

    // Back from Results returns to the previous step (Supplemental Loads or Inspection Data).
    const resultsIndex = this.supplementalLoadsAvailable === 'yes' ? 5 : 4;
    if (currentIndex === resultsIndex) {
      this.goBackFromResults();
      return;
    }

    // In MFH flow, always return from Inspection Data (step 4/index 3)
    // back to Component MFH (step 3/index 2).
    if (this.isMfhMode && currentIndex === 3) {
      this.stepNav.goToIndex(this.myStepper, 2, this.syncLinear);
      return;
    }

      // If we are on Step 3 (Component MAWP/MAEP) and Spherical or Cylindrical Atmospheric was selected, skip back over Step 2 to Step 1
      if (currentIndex === 2 && (isSphericalSelected || isCylindricalAtmosphericSelected)) {
      this.stepNav.goToIndex(this.myStepper, currentIndex - 2, this.syncLinear);
      return;
    }

    // Normal back behavior
    this.stepNav.previous(this.myStepper, false);
  }

  goBackFromResults() {
    const targetIndex = this.supplementalLoadsAvailable === 'yes' ? 4 : 3;
    this.stepNav.goToIndex(this.myStepper, targetIndex, this.syncLinear);
    this.updateGmlPageQueryParam(this.supplementalLoadsAvailable === 'yes' ? null : "inspection-data");
  }

  // Inspection Data emits nextStep only when calculation/validation succeeds.
  // Route that success path directly to the Results page state.
  goToResultsPageFromInspectionData() {
    const targetIndex = this.supplementalLoadsAvailable === 'yes' ? 5 : 4;
    this.stepNav.goToIndex(this.myStepper, targetIndex, this.syncLinear);
    this.updateGmlPageQueryParam("results");
  }

  private updateGmlPageQueryParam(page: "inspection-data" | "results" | null): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  private syncStepToPageQueryParam(page: string | null): void {
    if (page === "results") {
      this.stepNav.goToIndex(this.myStepper, 4, this.syncLinear);
      return;
    }

    if (page === "inspection-data") {
      this.stepNav.goToIndex(this.myStepper, 3, this.syncLinear);
    }
  }

  ngOnInit(): void {
    // Set current module to GML for feature management
    this.moduleConfigService.setCurrentModule(AssessmentModule.GML);

    // Load supplementalLoadsSelection from localStorage if present
    const storedSupp = localStorage.getItem('supplementalLoadsSelection');
    if (storedSupp) {
      this.supplementalLoadsSelection = storedSupp;
    }
    CalcTemplate.reset_data();
    this.applicability = `  
      <ol>  
        <li>The original design criteria were in accordance with a recognized code or standard.</li>  
        <li>The component is not operating in the creep range. See the Help Menu for temperature limit used to define the creep range.</li>
        <li>The region of metal loss has relatively smooth contours without notches, i.e. negligible local stress concentrations.</li>  
        <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
      <!-- <li>Type A components subject to internal pressure or external pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness. Examples are:  
          <ol type="a">  
            <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
                
            <li>Spherical pressure vessels and storage spheres</li>  
            <li>Spherical, elliptical and torispherical formed heads</li>  
            <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li> 
               
            <li>Cylindrical atmospheric storage tank shell courses</li>  
          </ol>  
        </li> -->
      </ol>  
    `;
    this.summary = sessionStorage.getItem(this.gmlSummaryStorageKey) || "";
    this.inspectionDataResult = sessionStorage.getItem(this.gmlInspectionResultStorageKey) || "";

    // Keep URL query param and stepper index in sync for inspection-data/results page navigation.
    this.routePageSubscription = this.activatedRoute.queryParamMap.subscribe((params) => {
      this.syncStepToPageQueryParam(params.get("page"));
    });

    const pageFromUrl = this.activatedRoute.snapshot.queryParamMap.get("page");
    if (pageFromUrl === "results") {
      this.stepNav.setStep(4);
    } else if (pageFromUrl === "inspection-data") {
      this.stepNav.setStep(3);
    } else {
      this.stepNav.resetToApplicability();
    }
    

    this.formControlsEventProxyService
      .getGMLApplicabilityEventSubject()
      .subscribe((v) => {
        this.updateApplicabilityCheckboxToChecked();
        this.firstFormGroup.get('applicabilityCheckbox').enable();
      });
      // shameer- start
      this.formControlsEventProxyService
      .getGMLtypeAApplicabilitySubject()
      .subscribe((v) => {
        this.updatetypeACheckboxToChecked();
        this.firstFormGroup.get('typeACheckbox').enable();
        // Update supplementalLoadsSelection from localStorage if changed externally
        const storedSupp = localStorage.getItem('supplementalLoadsSelection');
        if (storedSupp) {
          this.supplementalLoadsSelection = storedSupp;
        }
      });

      this.formControlsEventProxyService
      .getGMLtypeAupdateradioSubject()
      .subscribe((v) => {
        this.updateradiobuttonafterimport();
        this.updatedamageafterimport();
        this.updatetooltip();
      });
     // shameer -end
      this.reevaluSub = this.componentService.reevaluButtonEnabled.subscribe(
      enabled => this.isreevalu = !enabled
    );
    this.subscribeToImportedLoadType();
  }

  goToMAWPComponent() {
      const diVal = this.generalmetalloss_formGroup.get('radioButton_DI')?.value;
      this.validationList = [];
      if (!diVal) {
        this.showDIRequiredMessage = true;
        this.generalmetalloss_formGroup.get('radioButton_DI')?.markAsTouched();
        this.generalmetalloss_formGroup.get('radioButton_DI')?.markAsDirty();
        return; // stay on Applied Load step
      }
      this.showDIRequiredMessage = false;
      this.goNextStep();
  }

  updateradiobuttonafterimport()
  {
    
    this.firstFormGroup.get('radio').patchValue(this.componentService.typearadioselectedValue.toString());
  
  }
  updatedamageafterimport() {
    this.applyImportedLoadType(
      this.componentService.typeDamageSelectedValue ||
      this.componentService.radioButtonDI
    );
  }

  private subscribeToImportedLoadType(): void {
    this.componentService.typeDamageSelected$.subscribe((value) => {
      this.applyImportedLoadType(value);
    });
  }

  private applyImportedLoadType(value: string): void {
    if (!value) {
      return;
    }

    const normalizedValue = value.toUpperCase();
    const isInternal = normalizedValue === "RADIOBUTTON1_DI_ENABLED";
    const isExternal = normalizedValue === "RADIOBUTTON2_DI_ENABLED";
    if (!isInternal && !isExternal) {
      return;
    }

    const loadingType = isInternal ? 0 : 1;
    const unitType = parseInt(localStorage.getItem("unitType"), 10) || 0;

    this.generalmetalloss_formGroup.get("radioButton_DI")?.setValue(value);
    GML_module.intLoadingType = loadingType;
    Component_MAWP.strRadio = loadingType;
    Component_MAEP.strRadio = loadingType;
    Component_MAWP.strD_class = "GML";
    Component_MAWP.strD_iclass = 0;
    Component_MAWP.intUnit_select = unitType;
    Component_MAEP.strD_class = "GML";
    Component_MAEP.strD_iclass = 0;
    Component_MAEP.intUnit_select = unitType;
    Form1.prev_strD_class = "GML";
    this.componentService.radioButtonDI = value;
    this.showDIRequiredMessage = false;
    this.updateLevel2Visibility();
    if (this.showLevelOfAssessment && this.verticalScreeningPassed) {
      this.onLevelOfAssessmentChange(
        GML_module.intAssessmentLevel === 1 ? "level1and2" : "level1"
      );
    }
  }

  updatetooltip()
  {
   // this.tooltipText1 = this.componentService.typeatypeAinput1val.toString();

    const a1 = this.componentService.typeatypeAinput1val.toString();
    const a2 = this.componentService.typeatypeAinput2val.toString()

    const ut = this.componentService.typeAUnitTypeval.toString();
    const typaPF = this.componentService.typeAresultjsnval.toString();
    
    const Passres = "\n\nThe component meets the Type A screeing criteria";
    const Failres = "\n\nThe component doesn't meet the Type A screeing criteria.";    

    if(this.componentService.typearadioselectedValue.toString()== "1")
    {
      if (ut == "0")
      {
        const l1 = "Vertical Location of the Flaw, H (inch)";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
      
        if(typaPF == "0")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
        }else if(typaPF == "1")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
        }
        
      }
      else if( ut == "1")
      {
        const l1 = "Vertical Location of the Flaw, H*  (mm) *";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
       
        if(typaPF == "0")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
      }

      this.tooltipText2 ="";
      this.tooltipText3 ="";
      this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "2")
    {
      if (ut == "0")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *";
          const l2 = "\nDistance between saddle supports Lss  (inch) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
         
        }
        else if( ut == "1")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
          const l2 = "\nDistance between saddle supports Lss  (mm) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }

        this.tooltipText1 ="";
        this.tooltipText3 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "3")
    {
      if (ut == "0")
        {
          const l1 = "Maximum Operating Temperature, Top  (℉)";
          const l2 = "\nPipe Nominal size, NPS  (inch)";
         
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        else if( ut == "1")
        {
          const l1 = "Maximum Operating Temperature, Top  (℃)";
          const l2 = "\nPipe Nominal size, NPS  (mm)";
          
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        this.tooltipText1 ="";
        this.tooltipText2 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "4")
    {
        if (ut == "0")
          {
            const l1 = "Maximum Operating Temperature, Top  (℉)";
            const l2 = "\nPipe Nominal size, NPS  (inch)";
           
        if(typaPF == "0")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
          }
          else if( ut == "1")
          {
            const l1 = "Maximum Operating Temperature, Top  (℃)";
            const l2 = "\nPipe Nominal size, NPS  (mm)";
           
            if(typaPF == "0")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
              }else if(typaPF == "1")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
              }
          }
          this.tooltipText1 ="";
          this.tooltipText2 ="";
          this.tooltipText3 ="";
     }
      else if (this.componentService.typearadioselectedValue.toString()== "5")
      {
          if (ut == "0")
            {
              
            }
            else if( ut == "1")
            {
              
            }
            this.tooltipText1 ="";
            this.tooltipText2 ="";
            this.tooltipText3 ="";
            this.tooltipText4 ="";
      }
      
  }
  
  updateApplicabilityCheckboxToChecked() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(true);
  }

  //shameer
  updateApplicabilityCheckboxToUnChecked() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(false);
  }

  GML_Assesment_Setup() {
    Component_MAWP.MAWP_initialize();
    GML_module.GML_initialize();

    Component_MAWP.strD_class = "GML";
    Component_MAWP.strD_iclass = 0;
    Component_MAWP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "GML";

    Component_MAEP.MAEP_initialize();
    GML_module.GML_initialize();

    Component_MAEP.strD_class = "GML";
    Component_MAEP.strD_iclass = 0;
    Component_MAEP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "GML";
  }

  handleSummaryData(data: any) {
    this.summary = data;
    sessionStorage.setItem(this.gmlSummaryStorageKey, this.summary || "");
  }

  handleInspectionData(data: any) {
    this.inspectionDataResult = data;
    sessionStorage.setItem(this.gmlInspectionResultStorageKey, this.inspectionDataResult || "");
  }

  calculateResult(): void {
    // Sync supplemental loads flag before calc in case it was reset
    if (this.supplementalLoadsAvailable === 'yes') {
      GML_module.isSupplementalLoadsAvailable = true;
    }
    this.inspectionDataCalculate.next(true);
  }

  ngAfterViewInit(): void {
    this.syncStepToPageQueryParam(this.activatedRoute.snapshot.queryParamMap.get("page"));
  }

  ngOnDestroy(): void {
    this.routePageSubscription?.unsubscribe();
  }
  onRadioChange(event:MatRadioChange)
  {
    console.log('Selected value',event.value);
    if(event.value ==1)
    {
    const dialogRef = this.dialog.open(VerticalvesselComponent,{  height : '725px' ,width :'1200px', disableClose :true});
    dialogRef.afterClosed().subscribe(result => { 
      if (result) {
        console.log('Data from dialog:', result.data1,result.data2); 
        if (result.cancel) {
        //clear all checkboxes
          this.updateTypeAradioToUncheck();
          this.updateApplicabilityCheckboxToUnChecked();
          this.updatetypeACheckboxToUnChecked();
          this.firstFormGroup.get('applicabilityCheckbox').disable();
          this.firstFormGroup.get('typeACheckbox').disable();
           //clear all tool tips
           this.tooltipText1="";
           this.tooltipText2="";
           this.tooltipText3="";
           this.tooltipText4=""; 
          

        } else {
          console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
          if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
            {
                // Handle supplemental loads selection from dialog
                const suppSelection = result.value[2] || '';
                this.supplementalLoadsAvailable = suppSelection;
                this.supplementalLoadsSelection = suppSelection;
                localStorage.setItem('supplementalLoadsSelection', suppSelection);

                if (suppSelection === 'yes') {
                  // When supplemental loads available, enable 'All conditions met' checkbox
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.showSupplementalInputs = true;
                  GML_module.isSupplementalLoadsAvailable = true;
                  this.supplementalMessage = 'Type B Class 1 Component \u2013 supplemental loads will be entered at a later step.';
                } else {
                  // No supplemental loads: enable 'Proceed excluding Type A' checkbox
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();
                  this.showSupplementalInputs = false;
                  GML_module.isSupplementalLoadsAvailable = false;
                  if (suppSelection === 'no') {
                    this.supplementalMessage = 'Proceed with the assessment excluding Type A Component screening results.';
                  }
                }

                //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");

                //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;
                
               this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }
                          
                             
                 
            }
            else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
              {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').enable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').disable();

                // Reset supplemental loads selection on pass
                this.supplementalLoadsSelection = '';
                this.supplementalLoadsAvailable = '';
                localStorage.removeItem('supplementalLoadsSelection');

                //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                
                //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }

              }
        }
        //localStorage.setItem("TypeAselection","0");// Shameer - created for maintaining the selection of radio buttons.
      }
      // Update Level 2 visibility after vertical vessel screening result
      this.updateLevel2Visibility();
    });   

    localStorage.setItem("TypeAselection","1"); // as we selected vertical
    this.componentService.updateTypeASelectedValue(1);
    localStorage.setItem("TypeAradioselection","1"); 
    
  
    }
    else if(event.value==2)
    {
      const dialogRef = this.dialog.open(HorizontalvesselComponent,{ height : '650px' ,width :'1200px',disableClose :true})
     
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();
             //clear all tool tips
             this.tooltipText1="";
             this.tooltipText2="";
             this.tooltipText3="";
             this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                // Handle supplemental loads selection from dialog
                const suppSelection = result.value[2] || '';
                this.supplementalLoadsAvailable = suppSelection;
                this.supplementalLoadsSelection = suppSelection;
                localStorage.setItem('supplementalLoadsSelection', suppSelection);

                if (suppSelection === 'yes') {
                  // When supplemental loads available, enable 'All conditions met' checkbox
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.showSupplementalInputs = true;
                  GML_module.isSupplementalLoadsAvailable = true;
                  this.supplementalMessage = 'Type B Class 1 Component \u2013 supplemental loads will be entered at a later step.';
                } else {
                  // No supplemental loads: enable 'Proceed excluding Type A' checkbox
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();
                  this.showSupplementalInputs = false;
                  GML_module.isSupplementalLoadsAvailable = false;
                  if (suppSelection === 'no') {
                    this.supplementalMessage = 'Proceed with the assessment excluding Type A Component screening results.';
                  }
                }

               //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";
               


                 //for tooltip on vessels
                 const userinputs = localStorage.getItem('horizontalinputs');
                 const Input_data = userinputs ? JSON.parse(userinputs) : null;
                 const a1 = Input_data.inputvalue1;
                 const a2 = Input_data.inputvalue2;

                 this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;

              }
                          
                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");

              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                // Reset supplemental loads selection on pass
                this.supplementalLoadsSelection = '';
                this.supplementalLoadsAvailable = '';
                localStorage.removeItem('supplementalLoadsSelection');

                //for enabling Reeval button
                this.isreevalu = false;
                //for removing vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('horizontalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
 
               }

                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      localStorage.setItem("TypeAselection","2"); // as we selected Horizontal
      this.componentService.updateTypeASelectedValue(2);
      localStorage.setItem("TypeAradioselection","2"); 
    }
    else if(event.value==3)
    {
      const dialogRef = this.dialog.open(CarbonsteelandlowalloysteelComponent,{height : '520px' ,width :'1200px',disableClose :true})
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

            //clear all tool tips
            this.tooltipText1="";
            this.tooltipText2="";
            this.tooltipText3="";
            this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  // Handle supplemental loads selection from dialog
                  const suppSelection = result.value[2] || '';
                  this.supplementalLoadsAvailable = suppSelection;
                  this.supplementalLoadsSelection = suppSelection;
                  localStorage.setItem('supplementalLoadsSelection', suppSelection);

                  if (suppSelection === 'yes') {
                    // When supplemental loads available, enable 'All conditions met' checkbox
                    this.updatetypeACheckboxToUnChecked();
                    this.firstFormGroup.get('typeACheckbox').disable();
                    this.updateApplicabilityCheckboxToUnChecked();
                    this.firstFormGroup.get('applicabilityCheckbox').enable();
                    this.showSupplementalInputs = true;
                    GML_module.isSupplementalLoadsAvailable = true;
                    this.supplementalMessage = 'Type B Class 1 Component \u2013 supplemental loads will be entered at a later step.';
                  } else {
                    // No supplemental loads: enable 'Proceed excluding Type A' checkbox
                    this.updateApplicabilityCheckboxToUnChecked();
                    this.firstFormGroup.get('applicabilityCheckbox').disable();
                    this.updatetypeACheckboxToUnChecked();
                    this.firstFormGroup.get('typeACheckbox').enable();
                    this.showSupplementalInputs = false;
                    GML_module.isSupplementalLoadsAvailable = false;
                    if (suppSelection === 'no') {
                      this.supplementalMessage = 'Proceed with the assessment excluding Type A Component screening results.';
                    }
                  }

                  //for enabling Reeval button
                this.isreevalu = false;

                   //for removing tool tips of vertical/horizontal /highalloy  tooltip
                   this.tooltipText1="";
                   this.tooltipText2="";
                   this.tooltipText4="";
   
   
                   //for tooltip on vessels
                   const userinputs = localStorage.getItem('carbonsteelinputs');
                   const Input_data = userinputs ? JSON.parse(userinputs) : null;
                   const a1 = Input_data.inputvalue1;
                   const a2 = Input_data.inputvalue2;

                   this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                   if(this.intUnittype==0) //us customary
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
                  }
                  else if(this.intUnittype == 1) //si units
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
    
                  }

                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                  // Reset supplemental loads selection on pass
                  this.supplementalLoadsSelection = '';
                  this.supplementalLoadsAvailable = '';
                  localStorage.removeItem('supplementalLoadsSelection');

                  //for enabling Reeval button
                   this.isreevalu = false;

                    //for removing tool tips of vertical/horizontal /highalloy  tooltip
                    this.tooltipText1="";
                    this.tooltipText2="";
                    this.tooltipText4="";
    
    
                    //for tooltip on vessels
                    const userinputs = localStorage.getItem('carbonsteelinputs');
                    const Input_data = userinputs ? JSON.parse(userinputs) : null;
                    const a1 = Input_data.inputvalue1;
                    const a2 = Input_data.inputvalue2;

                    this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                   if(this.intUnittype==0) //us customary
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                    const res = "\n\nThe component meets the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
                  }
                  else if(this.intUnittype == 1) //si units
                  {
                    const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                    const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                    const res = "\n\nThe component meets the Type A screeing criteria."
                    this.tooltipText3 = lbl1+a1+lbl2+a2+res;
    
                  }

                  //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      localStorage.setItem("TypeAselection","3"); // as we selected carbon and low alloy
      this.componentService.updateTypeASelectedValue(3);
      localStorage.setItem("TypeAradioselection","3"); 
    }
    else if(event.value==4)
    {
       const dialogRef = this.dialog.open(HighalloyandnonferroussteelComponent,{height : '520px' ,width :'1200px', disableClose :true})
       dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

            //clear all tool tips
            this.tooltipText1="";
            this.tooltipText2="";
            this.tooltipText3="";
            this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  // Handle supplemental loads selection from dialog
                  const suppSelection = result.value[2] || '';
                  this.supplementalLoadsAvailable = suppSelection;
                  this.supplementalLoadsSelection = suppSelection;
                  localStorage.setItem('supplementalLoadsSelection', suppSelection);

                  if (suppSelection === 'yes') {
                    // When supplemental loads available, enable 'All conditions met' checkbox
                    this.updatetypeACheckboxToUnChecked();
                    this.firstFormGroup.get('typeACheckbox').disable();
                    this.updateApplicabilityCheckboxToUnChecked();
                    this.firstFormGroup.get('applicabilityCheckbox').enable();
                    this.showSupplementalInputs = true;
                    GML_module.isSupplementalLoadsAvailable = true;
                    this.supplementalMessage = 'Type B Class 1 Component \u2013 supplemental loads will be entered at a later step.';
                  } else {
                    // No supplemental loads: enable 'Proceed excluding Type A' checkbox
                    this.updateApplicabilityCheckboxToUnChecked();
                    this.firstFormGroup.get('applicabilityCheckbox').disable();
                    this.updatetypeACheckboxToUnChecked();
                    this.firstFormGroup.get('typeACheckbox').enable();
                    this.showSupplementalInputs = false;
                    GML_module.isSupplementalLoadsAvailable = false;
                    if (suppSelection === 'no') {
                      this.supplementalMessage = 'Proceed with the assessment excluding Type A Component screening results.';
                    }
                  }

                  //for enabling Reeval button
                this.isreevalu = false;

                 //for removing tool tips of vertical/horizontal /carbon tooltip
                 this.tooltipText1="";
                 this.tooltipText2="";
                 this.tooltipText3="";
 
 
                 //for tooltip on vessels
                 const userinputs = localStorage.getItem('highalloyinputs');
                 const Input_data = userinputs ? JSON.parse(userinputs) : null;
                 const a1 = Input_data.inputvalue1;
                 const a2 = Input_data.inputvalue2;

                 this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                 if(this.intUnittype==0) //us customary
                {
                  const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                  const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                  const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                  this.tooltipText4 = lbl1+a1+lbl2+a2+res;
                }
                else if(this.intUnittype == 1) //si units
                {
                  const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                  const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                  const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                  this.tooltipText4 = lbl1+a1+lbl2+a2+res;
  
                }

                //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                  // Reset supplemental loads selection on pass
                  this.supplementalLoadsSelection = '';
                  this.supplementalLoadsAvailable = '';
                  localStorage.removeItem('supplementalLoadsSelection');

                  //for enabling Reeval button
                this.isreevalu = false;

                 //for removing tool tips of vertical/horizontal /carbon tooltip
                 this.tooltipText1="";
                 this.tooltipText2="";
                 this.tooltipText3="";
 
 
                 //for tooltip on vessels
                 const userinputs = localStorage.getItem('highalloyinputs');
                 const Input_data = userinputs ? JSON.parse(userinputs) : null;
                 const a1 = Input_data.inputvalue1;
                 const a2 = Input_data.inputvalue2;

                 this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                 if(this.intUnittype==0) //us customary
                {
                  const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                  const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                  const res = "\n\nThe component meets the Type A screeing criteria."
                  this.tooltipText4 = lbl1+a1+lbl2+a2+res;
                }
                else if(this.intUnittype == 1) //si units
                {
                  const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                  const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                  const res = "\n\nThe component meets the Type A screeing criteria."
                  this.tooltipText4 = lbl1+a1+lbl2+a2+res;
  
                }

                //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      localStorage.setItem("TypeAselection","4"); // as we selected HighAlloy
      this.componentService.updateTypeASelectedValue(4);
      localStorage.setItem("TypeAradioselection","4"); 
    }
    else if(event.value==7)
    {
      this.isreevalu = false;

      this.tooltipText1="";
      this.tooltipText2="";
      this.tooltipText3="";
      this.tooltipText4="";

      this.updateApplicabilityCheckboxToUnChecked();
      this.firstFormGroup.get('applicabilityCheckbox').enable();
      this.updatetypeACheckboxToUnChecked();
      this.firstFormGroup.get('typeACheckbox').disable();

      localStorage.setItem("TypeAPassorFail","1");
      localStorage.setItem("TypeAselection","7");
      this.componentService.updateTypeASelectedValue(7);
      localStorage.setItem("TypeAradioselection","7");
    }
    else
    {
      if(event.value==5)  // when 2nd line radio button is selected , consider typeA as passed
      {
        //for enabling Reeval button
        this.isreevalu = false;

        //clear all tool tips
        this.tooltipText1="";
        this.tooltipText2="";
        this.tooltipText3="";
        this.tooltipText4="";

         //for typea result in report generation
         localStorage.setItem("TypeAPassorFail","1");

        // Spherical components support only Internal Pressure.
        this.onChangeRadioButton1_DI('radioButton1_DI_enabled');
      }
      // when we select 5 (and any remaining grouped options)
       this.updateApplicabilityCheckboxToUnChecked();
       this.firstFormGroup.get('applicabilityCheckbox').enable();
       this.updatetypeACheckboxToUnChecked();
       this.firstFormGroup.get('typeACheckbox').disable();
       localStorage.setItem("TypeAselection","5"); // as we selected Spherical components
       this.componentService.updateTypeASelectedValue(5);

       localStorage.setItem("TypeAradioselection","5"); 
    }
   
  }
  

  updateTypeAradioToUncheck()
  {
    this.firstFormGroup.get('radio').patchValue(null);    
  }

  gettypeAradio_formControl(): FormControl {
    return this.firstFormGroup.get("radio") as FormControl;
  }

  updatetypeACheckboxToChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(true);
  }

  updatetypeACheckboxToUnChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(false);
  }
  gettypeACheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  } 
  typeareevaluate()
  {
    this.updateTypeAradioToUncheck();
    this.updateApplicabilityCheckboxToUnChecked();
    this.updatetypeACheckboxToUnChecked();
    this.firstFormGroup.get('applicabilityCheckbox').disable();
    this.firstFormGroup.get('typeACheckbox').disable();
    
    //for disbling Reeval button
    this.isreevalu = true;
    this.tooltipText1="";
    this.tooltipText2="";
    this.tooltipText3="";
    this.tooltipText4="";
    localStorage.removeItem('verticalinputs');

    
   
  }
    async onChangeRadioButton1_DI(value: string) {
    const previousValue = this.componentService.radioButtonDI;
    // Save the value in your form if needed
    this.generalmetalloss_formGroup.get('radioButton_DI').setValue(value);
    
    // When switching Internal/External, force component-type dropdowns back to Select Type
    // and clear data in subsequent screens to avoid calculation errors.
    if (previousValue && previousValue !== value) {
      const confirmed = await this.componentService.confirmAssessmentContextChange();
      if (!confirmed) {
        this.generalmetalloss_formGroup.get('radioButton_DI').setValue(previousValue);
        return;
      }
      Component_MAWP.intEquip = -1;
      Component_MAEP.intEquip = -1;
      this.componentService.updateCompMAWPintEquip(-1);
      this.componentService.updateCompMAEPintEquip(-1);
      // Reset module and component data to prevent stale data in next screens
      Component_MAWP.MAWP_initialize();
      Component_MAEP.MAEP_initialize();
      GML_module.GML_initialize();
      this.summary = "";
      this.inspectionDataResult = "";
      this.result = "";
      this.validationList = [];
      sessionStorage.removeItem(this.gmlSummaryStorageKey);
      sessionStorage.removeItem(this.gmlInspectionResultStorageKey);
      this.componentService.notifySilentAssessmentContextReset();
    }
    // Clear any DI required message once user selects a value
    this.showDIRequiredMessage = false;

    // Set GML_module.intLoadingType based on selection
    if (value.toString().toUpperCase() === 'RADIOBUTTON1_DI_ENABLED') {
         GML_module.intLoadingType = 0; // Internal Pressure
        // Store radio button value in both components
        Component_MAWP.strRadio = 0;
        Component_MAEP.strRadio = 0;
        Component_MAWP.strD_class = "GML";
        Component_MAWP.strD_iclass = 0;
        Component_MAWP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
        Form1.prev_strD_class = "GML";
    } else if (value.toString().toUpperCase() === 'RADIOBUTTON2_DI_ENABLED') {
      GML_module.intLoadingType = 1; // External Pressure
        // // Store radio button value in both components
         Component_MAWP.strRadio = 1;
        Component_MAEP.strRadio = 1;
        Component_MAEP.strD_class = "GML";
        Component_MAEP.strD_iclass = 0;
        Component_MAEP.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
        Form1.prev_strD_class = "GML";
        }
    // Store in service instead of localStorage
     this.componentService.radioButtonDI = value;

    // Update Level 2 visibility based on load type selection
    this.updateLevel2Visibility();
  }

  // Level 2 Assessment methods
  updateLevel2Visibility() {
    const typeARadio = parseInt(localStorage.getItem("TypeAradioselection") || "0", 10);
    const typeAPassOrFail = parseInt(localStorage.getItem("TypeAPassorFail") || "-1", 10);
    const isInternalPressure = this.generalmetalloss_formGroup.get('radioButton_DI')?.value === 'radioButton1_DI_enabled';

    this.isVerticalVessel = typeARadio === 1;
    this.verticalScreeningPassed = typeAPassOrFail === 1;

    // Show Level of Assessment only for vertical vessels with internal pressure
    if (this.isVerticalVessel && isInternalPressure) {
      if (this.verticalScreeningPassed) {
        // Screening passed: show Level 1 / Level 1 and Level 2 option
        this.showLevelOfAssessment = true;
        this.showSupplementalLoads = false;
      } else {
        // Screening failed: auto-select Level 1+2 and show supplemental loads option
        this.showLevelOfAssessment = true;
        this.showSupplementalLoads = true;
        this.levelOfAssessment = 'level1and2';
        GML_module.intAssessmentLevel = 1;
        // Restore supplemental loads flag from stored selection
        if (this.supplementalLoadsAvailable === 'yes') {
          GML_module.isSupplementalLoadsAvailable = true;
        }
      }
    } else {
      this.showLevelOfAssessment = false;
      this.showSupplementalLoads = false;
      this.levelOfAssessment = 'level1';
      GML_module.intAssessmentLevel = 0;
      GML_module.isSupplementalLoadsAvailable = false;
    }
  }

  onLevelOfAssessmentChange(value: string) {
    this.levelOfAssessment = value;
    if (value === 'level1and2') {
      GML_module.intAssessmentLevel = 1;
    } else {
      GML_module.intAssessmentLevel = 0;
    }
  }

  onSupplementalLoadsChange(value: string) {
    this.supplementalLoadsAvailable = value;
    if (value === 'yes') {
      this.showSupplementalInputs = true;
      GML_module.isSupplementalLoadsAvailable = true;
      this.supplementalMessage = 'Type B Class 1 Component \u2013 supplemental loads will be entered at a later step.';
    } else {
      this.showSupplementalInputs = false;
      GML_module.isSupplementalLoadsAvailable = false;
      this.supplementalMessage = 'Proceed with the assessment excluding Type A Component screening results.';
    }
  }

  onBendingMomentChange(value: string) {
    const num = parseFloat(value);
    if (!isNaN(num) && num > 0) {
      GML_module.sngM_bending = num;
    }
  }

  onWeightChange(value: string) {
    const num = parseFloat(value);
    if (!isNaN(num) && num > 0) {
      GML_module.sngF_weight = num;
    }
  }

  onApexAngleChange(value: string) {
    const num = parseFloat(value);
    if (!isNaN(num) && num >= 0) {
      GML_module.sngAlpha_cone = num;
    }
  }

  onFmlChange(value: string) {
    const num = parseFloat(value);
    if (!isNaN(num)) {
      GML_module.sngF_ml = num;
    }
  }

  onMmlChange(value: string) {
    const num = parseFloat(value);
    if (!isNaN(num) && num >= 0) {
      GML_module.sngM_ml = num;
    }
  }

  onSupplementalLoadsDataChanged(data: SupplementalLoadsData): void {
    GML_module.sngF_ml = data.fml;
    GML_module.sngM_ml = data.mml;
  }
}
